// Pincode Checker Popup with Add To Cart
function initializeCustomAddToCart(quickBuyElement) {
  const addToCartButtons = document.querySelectorAll("#CustomAddToCart");
  addToCartButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      handleCustomFormSubmit(e, quickBuyElement);
    });
  });
}

document.addEventListener("quick_buy_loaded", (e) => {
  const quickBuyElement = e.detail.element;
  initializeCustomAddToCart(quickBuyElement);
});

document.addEventListener("facet:criteria-changed", () => {
  console.log("called facet");
  setTimeout(() => {
    initializeCustomAddToCart();
  }, 500);
});

document.addEventListener("DOMContentLoaded", () => {
  initializeCustomAddToCart();
});

const DELIVERY_PINCODE_CHECK_URL =
  "https://manam.apps.iterator.in/api/stores/check-delivery-pincode/";

const PINCODE_FAIL_COPY = {
  local: {
    title: "We are currently not delivering this product to your pincode",
    subtitleHtml:
      "This product is temperature-sensitive and may lose quality in high temperatures. Browse our Snacking and Tablet craft chocolate experiences.",
  },
  default: {
    title: "Uh-Oh! we're not delivering to this area yet!",
    subtitleHtml:
      "We're working on expanding our delivery areas. Leave your email address,<br>and we'll let you know once we're available in your<br>location.",
  },
};

function syncPincodeProductLocalFromSource(sourceEl) {
  if (!sourceEl?.getAttribute) return;
  const local = sourceEl.getAttribute("data-product-local");
  if (local !== "true" && local !== "false") return;
  document.querySelectorAll("pincode-checker").forEach((checker) => {
    checker.setAttribute("data-product-local", local);
    if (typeof checker.syncFailedDeliveryMessages === "function") {
      checker.syncFailedDeliveryMessages();
    }
  });
}

async function fetchDeliveryServiceable(pincode, productId) {
  const res = await fetch(
    `${DELIVERY_PINCODE_CHECK_URL}?pincode=${encodeURIComponent(
      pincode
    )}&product=${encodeURIComponent(productId)}`
  );
  const data = await res.json();
  return { ok: res.ok, data };
}

const CUSTOM_ATC_SPINNER_HTML = `<div class="spinner" aria-hidden="true"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div>`;

function setCustomAddToCartLoading(button, loading) {
  if (!button) return;
  if (loading) {
    if (button.hasAttribute("data-custom-atc-loading")) return;
    button.setAttribute("data-custom-atc-loading", "");
    button.dataset.customAtcPrevDisabled = button.disabled ? "1" : "0";
    button.dataset.customAtcPrevHtml = button.innerHTML;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    button.classList.add("custom-add-to-cart--loading");
    button.innerHTML = `<span class="custom-add-to-cart-loading" style="display:inline-flex;align-items:center;justify-content:center;gap:10px;">${CUSTOM_ATC_SPINNER_HTML}</span>`;
  } else {
    if (!button.hasAttribute("data-custom-atc-loading")) return;
    button.removeAttribute("data-custom-atc-loading");
    const prevDisabled = button.dataset.customAtcPrevDisabled === "1";
    delete button.dataset.customAtcPrevDisabled;
    button.removeAttribute("aria-busy");
    button.classList.remove("custom-add-to-cart--loading");
    if (button.dataset.customAtcPrevHtml !== undefined) {
      button.innerHTML = button.dataset.customAtcPrevHtml;
      delete button.dataset.customAtcPrevHtml;
    }
    button.disabled = prevDisabled;
  }
}

async function handleCustomFormSubmit(e, quickBuyElement) {
  e.preventDefault();

  const addButton = e.currentTarget;
  const pincodeElement = document.querySelector("pincode-checker");
  if (pincodeElement) {
    pincodeElement.setAttribute("data-product-id", addButton.dataset.productId);
    pincodeElement.setAttribute(
      "data-product-title",
      addButton.dataset.productTitle
    );
    pincodeElement.setAttribute("data-form-id", addButton.dataset.formId);
    syncPincodeProductLocalFromSource(addButton);
    const pincodeModal = pincodeElement.querySelector(`#pincode-checker-modal`);

    console.log("PincodeModal->>>", pincodeModal);
    const savedPincode = localStorage.getItem("pincode");
    if (!savedPincode) {
      pincodeModal.setAttribute("open", "");
      if (quickBuyElement) quickBuyElement.removeAttribute("open");
      return;
    }

    const formElement = document.getElementById(addButton.dataset.formId);
    const productId = addButton.dataset.productId;

    if (quickBuyElement) quickBuyElement.removeAttribute("open");

    const pincodeDigits = String(savedPincode).replace(/\D/g, "");
    if (pincodeDigits.length !== 6) {
      pincodeElement.openPincodeModalForManualCheck(savedPincode);
      return;
    }

    setCustomAddToCartLoading(addButton, true);
    try {
      const { data } = await fetchDeliveryServiceable(pincodeDigits, productId);
      if (data?.serviceable) {
        localStorage.setItem("pincode", pincodeDigits);
        localStorage.setItem("productId", productId);
        await addProductsToCart(formElement, pincodeModal);
      } else {
        pincodeElement.showDeliveryUnavailable(pincodeDigits, data);
      }
    } catch (err) {
      console.log("Pincode verify before cart error: ", err);
      pincodeElement.openPincodeModalForManualCheck(pincodeDigits);
    } finally {
      setCustomAddToCartLoading(addButton, false);
    }
  }
}

async function addProductsToCart(formElement, pincodeModal) {
  if (!formElement && pincodeModal.hasAttribute("open")) {
    pincodeModal.removeAttribute("open");
    return;
  }

  const productForm = new FormData(formElement);
  productForm.append("sections", ["mini-cart"]);
  productForm.delete("option1");
  productForm.delete("option2");
  productForm.delete("option3");
  const response = await fetch(
    `${window.themeVariables.routes.cartAddUrl}.js`,
    {
      body: productForm,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    }
  );
  const responseJson = await response.json();
  console.log("responseJson", responseJson);
  if (response.ok) {
    if (
      window.themeVariables.settings.cartType === "page" ||
      window.themeVariables.settings.pageType === "cart"
    ) {
      return (window.location.href = `${Shopify.routes.root}cart`);
    }
    const variantEventTarget = formElement || document.documentElement;
    variantEventTarget.dispatchEvent(
      new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items")
            ? responseJson["items"][0]
            : responseJson,
        },
      })
    );
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
      async (response2) => {
        const cartContent = await response2.json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
        const cart = document.getElementById("mini-cart");
        cart.setAttribute("open", "");
      }
    );
    if (pincodeModal.hasAttribute("open")) {
      pincodeModal.removeAttribute("open");
    }
  }
}

class PincodeCheckerForm extends HTMLElement {
  constructor() {
    super();
    this.panIndia = this.getAttribute("data-panindia") === "true";
    this.twelveKMProduct =
      this.getAttribute("data-twelve-km-product") === "true";
    this.localMsg =
      this.getAttribute("data-local-msg") || "Delivery available in your area.";
    this.panIndiaMsg =
      this.getAttribute("data-pan-msg") || "Delivery available in your area.";

    this.pincodeModal = this.querySelector(".pincode-checker-modal");
    this.pincodeCheckerContent = this.querySelector(".pincode-checker-content");
    this.pincodeForm = this.querySelector(".pincode-form");
    this.deliveryMsg = this.querySelector(".delivering");
    this.pincodeInput = this.querySelector(".pincodeNumber");
    this.pincodeCheckerButton = this.querySelector(".pincodeChecker");
    this.sendUserDetailButton = this.querySelector(".sendUserDetails");
    this.failedPincodesDetails = this.querySelector(".failed_pincodes_details");
    this.changePincodeBtn = this.querySelector(".new_pincode_check");
    this.failedTitleEl = this.failedPincodesDetails?.querySelector(".title");
    this.failedSubtitleEl =
      this.failedPincodesDetails?.querySelector(".sub-title");
  }

  syncFailedDeliveryMessages() {
    const isLocal = this.getAttribute("data-product-local") === "true";
    const copy = isLocal ? PINCODE_FAIL_COPY.local : PINCODE_FAIL_COPY.default;
    if (this.failedTitleEl) {
      this.failedTitleEl.textContent = copy.title;
    }
    if (this.failedSubtitleEl) {
      this.failedSubtitleEl.innerHTML = copy.subtitleHtml;
    }
  }

  showDeliveryUnavailable(pincodeDigits, apiData) {
    this.syncFailedDeliveryMessages();
    if (this.pincodeInput) this.pincodeInput.value = pincodeDigits;
    if (this.pincodeCheckerButton) {
      this.pincodeCheckerButton.style.backgroundColor = "";
      this.pincodeCheckerButton.textContent = "CHECK";
    }
    this.pincodeCheckerContent.style.display = "none";
    this.failedPincodesDetails.style.display = "block";
    this.failedPincodeId = apiData?.failed_pincode_id || null;
    this.pincodeModal.setAttribute("open", "");
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true })
    );
  }

  openPincodeModalForManualCheck(pincodeValue) {
    this.pincodeCheckerContent.style.display = "block";
    this.failedPincodesDetails.style.display = "none";
    if (this.pincodeInput) this.pincodeInput.value = pincodeValue || "";
    if (this.pincodeCheckerButton) {
      this.pincodeCheckerButton.style.backgroundColor = "";
      this.pincodeCheckerButton.textContent = "CHECK";
    }
    this.pincodeModal.setAttribute("open", "");
  }

  connectedCallback() {
    if (this.pincodeCheckerButton) {
      this.pincodeCheckerButton.addEventListener(
        "click",
        this.checkPincode.bind(this)
      );
    }

    if (this.sendUserDetailButton) {
      this.sendUserDetailButton.addEventListener(
        "click",
        this.sendFailedPincodes.bind(this)
      );
    }
    if (this.changePincodeBtn) {
      this.changePincodeBtn?.addEventListener(
        "click",
        this.changePincode.bind(this)
      );
    }
    if (this.pincodeInput) {
      this.pincodeInput.addEventListener("keydown", (event) => {
        const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab"];
        if (!/\d/.test(event.key) && !allowedKeys.includes(event.key)) {
          event.preventDefault();
        }
      });
      this.pincodeInput.addEventListener("input", (event) => {
        event.target.value = event.target.value.replace(/\D/g, "");
      });
    }

    const cookieVal = localStorage.getItem("pincode");
    const cookieProductId = localStorage.getItem("productId");
    if (cookieVal && cookieProductId) {
      this.pincodeInput.value = cookieVal;
      setTimeout(() => {
        this.pincodeCheckerButton.click();
      }, 1000);
    }

    this.syncFailedDeliveryMessages();
  }

  async checkPincode(e) {
    const productId =
      this.getAttribute("data-product-id") || localStorage.getItem("productId");
    const pincodeNumber = this.pincodeInput.value;

    if (pincodeNumber.length === 6) {
      console.log("Pincode entered:", pincodeNumber);
      try {
        const { data } = await fetchDeliveryServiceable(
          pincodeNumber,
          productId
        );

        if (data?.serviceable) {
          localStorage.setItem("pincode", pincodeNumber);
          localStorage.setItem("productId", productId);
          this.pincodeCheckerButton.style.backgroundColor = "#48B02C";
          this.pincodeCheckerButton.textContent = "DELIVERY AVAILABLE";

          if (this.getAttribute("data-cart-pincode")) {
            this.pincodeModal.removeAttribute("open");
          }
          if (
            this.pincodeModal.hasAttribute("open") &&
            !this.getAttribute("data-cart-pincode")
          ) {
            this.handleFormSubmit(e);
          }
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })
          );
        } else {
          localStorage.removeItem("pincode");
          localStorage.removeItem("productId");
          this.syncFailedDeliveryMessages();
          this.pincodeCheckerContent.style.display = "none";
          this.failedPincodesDetails.style.display = "block";

          this.failedPincodeId = data?.failed_pincode_id || null;
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })
          );
        }
      } catch (error) {
        console.log("Error: ", error);
      }
    }
  }

  changePincode() {
    this.pincodeCheckerContent.style.display = "block";
    this.pincodeInput.focus();
    this.failedPincodesDetails.style.display = "none";
  }

  async sendFailedPincodes() {
    const url = `https://manam.apps.iterator.in/api/stores/failed-delivery-pincodes/${this.failedPincodeId}/`;
    const email = this.querySelector("#user_email_address")?.value?.trim();
    const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    console.log(email);
    if (!email || !emailRegExp.test(email)) {
      this.querySelector(".pincode_error").style.display = "block";
      this.querySelector(".pincode_error").innerHTML = `
        <span style='display: flex; align-items: center; gap: 5px;'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 20 20' fill='none'>
            <path d='M13.5 6L6 13.5' stroke='#E03232' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/>
            <path d='M6 6L13.5 13.5' stroke='#E03232' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/>
          </svg>
          Enter a valid email address.
        </span>`;
      return;
    }

    const payload = {
      pincode: this.pincodeInput?.value,
      email: email,
      product: this.getAttribute("data-product-id"),
    };

    const pincodeModal = this.pincodeModal;
    const sendUserDetailButton = this.sendUserDetailButton;

    try {
      const res = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      console.log("data", data);

      if (res.ok) {
        sendUserDetailButton.style.backgroundColor = "#48B02C";
        sendUserDetailButton.textContent = "You will be notified!!";

        setTimeout(() => {
          pincodeModal.removeAttribute("open");
        }, 2000);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  }

  async handleFormSubmit(e) {
    const formId = this.getAttribute("data-form-id");
    const productForm = document.getElementById(formId);
    await addProductsToCart(productForm, this.pincodeModal);
  }
}

window.customElements.define("pincode-checker", PincodeCheckerForm);

window.updatePincodeOnCart = function updatePincodeDetailsCart() {
  const pincodeDetailsElem = document.querySelector(
    ".mini-cart__pincode-details"
  );
  if (pincodeDetailsElem) {
    const pincode = pincodeDetailsElem?.querySelector(".pincode_selected");
    const localStoragePincode = localStorage.getItem("pincode");
    const localStorageProductId = localStorage.getItem("productId");
    if (localStoragePincode && localStorageProductId) {
      pincodeDetailsElem.style.display = "flex";
      pincode.textContent = localStoragePincode;
    }

    pincode?.addEventListener("click", (e) => {
      const productId = e.target.dataset.productId;
      const productTitle = e.target.dataset.productTitle;
      console.log("productId", productId);
      console.log("productTitle", productTitle);
      const PincodeCheckerForm = document.querySelector("pincode-checker");
      PincodeCheckerForm.setAttribute("data-product-id", productId);
      PincodeCheckerForm.setAttribute("data-product-title", productTitle);
      syncPincodeProductLocalFromSource(e.target);
      PincodeCheckerForm.setAttribute("data-cart-pincode", true);
      const pincodeModal = PincodeCheckerForm.querySelector(
        ".pincode-checker-modal"
      );
      const checkPincodeBtn =
        PincodeCheckerForm.querySelector(".pincodeChecker");
      const cart = document.getElementById("mini-cart");
      cart.removeAttribute("open", "");
      checkPincodeBtn.style.backgroundColor = "#000";
      checkPincodeBtn.style.color = "#fff";
      checkPincodeBtn.textContent = "CHECK";
      pincodeModal.setAttribute("open", "");
    });
  }
};

document.addEventListener("cart:refresh", window.updatePincodeOnCart);
